import {
    ContextMenu,
    ContextMenuContent,
    ContextMenuItem,
    ContextMenuSeparator,
    ContextMenuTrigger,
} from "@/components/ui/context-menu";

export const ManageRole = ({ children, roleId, handleDeleteRole, canBeDeleted, handleCloneRole }: { children: React.ReactNode, roleId: string, handleDeleteRole: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void, canBeDeleted: boolean, handleCloneRole: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void }) => {

    return (
        <ContextMenu>
            <ContextMenuTrigger>
                {children}
            </ContextMenuTrigger>
            <ContextMenuContent className="bg-brand-default min-w-60 p-0 px-0 py-0 space-y-0 font-bold rounded-lg text-white border-0 shadow-xl shadow-brand ">
                {canBeDeleted && (
                    <>
                        <ContextMenuSeparator />
                        <ContextMenuItem className="hover:bg-brand-profile text-white focus:text-gray-400 focus:bg-brand-profile" onClick={handleCloneRole}>
                            Clone Role
                        </ContextMenuItem>
                        <ContextMenuSeparator />
                        <ContextMenuItem className="hover:bg-brand-profile text-red-400 focus:text-red-400 focus:bg-brand-profile" onClick={handleDeleteRole}>
                            Delete Role
                        </ContextMenuItem>
                    </>
                )}

            </ContextMenuContent>
        </ContextMenu>
    );
};
